import React from 'react'
import { vapRoot, vasRoot } from '@liepin/js-core4c-fe';
import { Menu } from 'antd';

const ResumeOptimizationSubMenu: React.FC = () => (
  <Menu>
    <Menu.Item key="header-nav-menu-vap-goldcard">
      <a
        id="header-nav-menu-vap-goldcard"
        target="_blank"
        href={`${vapRoot}/view-goldcard?utm_content=jhyjkxl&imscid=R000014435`}
      >
        简历置顶
      </a>
    </Menu.Item>
    <Menu.Item key="header-nav-menu-coachintro">
      <a
        id="header-nav-menu-coachintro"
        target="_blank"
        href={`${vasRoot}/view-coachintro/?utm_content=jhymsjlxl&imscid=R000014434`}
      >
        面试辅导
      </a>
    </Menu.Item>
    <Menu.Item key="header-nav-menu-careerintro">
      <a
        id="header-nav-menu-careerintro"
        target="_blank"
        href={`${vasRoot}/view-careerintro/?utm_content=jhysyghxl&imscid=R000014436`}
      >
        职业咨询
      </a>
    </Menu.Item>
    <Menu.Item key="header-nav-menu-vas-sendforyou">
      <a
        id="header-nav-menu-vas-sendforyou"
        target="_blank"
        href={`${vasRoot}/view-sendforyou`}
      >
        简历代投
      </a>
    </Menu.Item>
  </Menu>
)

export default ResumeOptimizationSubMenu
